import { browser } from '$app/environment';
import Log from '../log';

export async function getImpactClickId(): Promise<string | undefined> {
	if (!browser) return;

	return new Promise((resolve) => {
		if (!window.ire) {
			resolve(undefined);
			return;
		}

		try {
			window.ire('generateClickId', (clickId: string | null) => resolve(clickId || undefined));
		} catch (e) {
			Log.scope('Impact').exception(e);
			resolve(undefined);
		}
	});
}
